<template>
  <b-row>
    <b-col md="10" lg="6" xl="5" cols="12" class="text-justify">
      <!-- <p class="my-2 py-2 fs-6">
        Verifica ed aggiorna le {{ type }} del paziente cliccando su "Verifica
        {{ type }} paziente". Dopo aver aggiornato le {{ type }}, completa
        ciascuna scheda con le informazioni mancanti.
      </p> -->
      <p class="my-2 py-2 fs-6">
        Clicca su "Verifica {{ type }}  paziente” per inserire le {{ type }} . Completa ciascuna scheda con le informazioni mancanti.
      </p>
    </b-col>
    <b-col class="align-self-center">
      <b-button @click="$bvModal.show(type + '_paziente')"
        >Verifica {{ type }} paziente</b-button
      ></b-col
    >
    <b-modal
      v-if="type === 'terapie'"
      id="terapie_paziente"
      hide-footer
      centered
      scrollable
      size="xl"
      title="Aggiorna terapie paziente"
      @hide="fetchUserTherapies"
    >
      <TerapieComponent
        :subject="{ type: 'user_in_app', hashid: patient.hashid }"
        :ricognizione="true"
      ></TerapieComponent>
    </b-modal>
    <b-modal
      v-if="type === 'patologie'"
      id="patologie_paziente"
      hide-footer
      centered
      scrollable
      size="xl"
      title="Aggiorna patologie paziente"
      @hide="fetchUserPathologies"
    >
      <PatologieComponents
        :subject="{ type: 'user_in_app', hashid: patient.hashid }"
      ></PatologieComponents>
    </b-modal>
  </b-row>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { cittadinoService } from "@/_services";
import PatologieComponents from "@/app/modules/servizi/profiloSanitario/components/PatologieComponent.vue";
import TerapieComponent from "@/app/modules/servizi/gestionePazienti/components/TerapieComponent.vue";

export default {
  name: "CompilatoreRicognizione",
  props: ["patient", "type", "template"],
  components: { PatologieComponents, TerapieComponent },
  data() {
    return {
      therapies: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
    }),
    fetchUserTherapies() {
      const self = this;
      const filters = {
        user: this.patient.hashid,
        scope: "ricognizione",
      };
      cittadinoService
        .getTherapies(filters)
        .then(function (response) {
          self.setupRicognizioneSchema(response.data.data);
        })
        .catch(function (error) {
          console.log("error", error);
          self.errorAlert("Non è stato possibile recuperare le terapie");
        });
    },
    fetchUserPathologies() {
      const self = this;
      const filters = {
        user: this.patient.hashid,
      };
      cittadinoService
        .getPathologies(filters)
        .then(function (response) {
          console.log(response.data.data);
          self.setupRicognizioneSchema(response.data.data);
        })
        .catch(function (error) {
          self.errorAlert("Non è stato possibile recuperare le patologie");
        });
    },
    setupRicognizioneSchema(dataSet) {
      if (this.template) {
        const self = this;
        var arraySchema = [];
        const terLen = dataSet.length;
        for (let i = 0; i < terLen; i++) {
          let schemaTemplate = [];
          Object.keys(self.template).map(function (el) {
            var answr = null;
            if (self.template[el].k) {
              answr = dataSet[i][self.template[el].k];
            }
            let newObj = {
              k: self.template[el].q,
              i: self.template[el].i,
              t: self.template[el].t,
              o: self.template[el].o,
              a: answr,
              q: self.template[el].q,
              r: self.template[el].r,
            };
            schemaTemplate.push(newObj);
          });
          arraySchema.push(schemaTemplate);
        }
        this.$emit("schema-ricognizione", arraySchema);
      }
    },
    fetchData() {
      if (this.type == "patologie") {
        this.fetchUserPathologies();
      } else {
        this.fetchUserTherapies();
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
